import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBorderRadiusOptions,
  getImageOpacityOptions,
  getObjectFitOptions,
  getObjectPositionOptions,
} from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "img",
  props: {
    image: {
      prop: "other",
      type: "circle-image-upload",
      value: {
        signed_id: null,
      },
    },
    alt: {
      prop: "other",
      type: "string",
      value: "",
    },
    href: {
      prop: "other",
      type: "url",
      value: "",
    },
    target: {
      prop: "other",
      type: "select",
      value: "_self",
      options: [
        {
          label: "Self",
          labelI18n: "builder_ui.prop_type.target_types.self",
          value: "_self",
        },
        {
          label: "Blank",
          labelI18n: "builder_ui.prop_type.target_types.blank",
          value: "_blank",
        },
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        objectFit: getObjectFitOptions({
          defaultValue: defaultStyles.objectFit,
        }),
        objectPosition: getObjectPositionOptions({
          defaultValue: defaultStyles.objectPosition,
        }),
        opacity: getImageOpacityOptions({
          defaultValue: defaultStyles.opacity,
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: defaultStyles.borderRadius,
        }),
        sizing: getSizingOptions({
          defaultValue: defaultStyles.sizing,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
